import React from 'react'
import { Themed } from '../components'
import styles from './Form.module.css'

const Form = props => (
  <Themed styles={styles} theme={props.theme}>
    {(cx, css) => (
      <div className={css.base}>
        {props.children}
      </div>
    )}
  </Themed>
)

const FormRow = props => (
  <Themed styles={styles} theme={props.theme}>
    {(cx, css) => (
      <div className={css.row}>
        {props.children}
      </div>
    )}
  </Themed>
)

const FormField = props => (
  <Themed styles={styles} theme={props.theme}>
    {(cx, css) => (
      <div className={css.field}>
        {props.children}
      </div>
    )}
  </Themed>
)

export default Form
export { FormRow, FormField }
